@let camera = cameraData();

<app-pan-card [header]="'Manage Camera'" [subheader]="cameraCardSubtitle()" [isPageContainer]="true" [pageContainerSize]="'xl'">
  <div leftActions></div>

  <div rightActions class="gap-2 flex">
    @if (camera) {
      <a
        panButton
        [color]="camera.status === 'GREEN' ? 'success' : 'danger'"
        fill="outline"
        icon="videocam"
        matTooltip="({{ camera.status === 'GREEN' ? 'Healthy' : 'Unhealthy' }}) Open in Rhombus"
        [href]="camera.camera_url"
        target="_blank"
      ></a>

      <app-pan-button color="info" (click)="cameraDisplayCheck.show()" [disabled]="isLoadingData() || disableActions()">
        View Snapshot
      </app-pan-button>
    }
  </div>

  @if (isLoadingData()) {
    <app-pan-blank-slate>
      <app-pan-spinner size="lg"></app-pan-spinner>
    </app-pan-blank-slate>
  } @else {
    <app-pan-modal #connectTerminalModal [topLevel]="false" [shouldBodyScroll]="false" size="md" (modalWillClose)="unsetSelectedTerminal()">
      <div header>Connnect to Terminal</div>
      <div body class="h-[100px]">
        <ng-select
          class="w-full mt-2"
          placeholder="Select terminal..."
          [items]="availableTerminals()"
          [bindLabel]="'fullName'"
          [virtualScroll]="true"
          [(ngModel)]="selectedTerminal"
          typeToSearchText="Please enter 3 or more characters"
        >
          <ng-template ng-option-tmp let-item="item">
            <div class="flex justify-between">
              {{ item.fullName }}
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div footer class="flex gap-2">
        <app-pan-button panModalClose>Cancel</app-pan-button>
        <app-pan-button color="primary" (click)="connectCameraToTerminal()" [disabled]="disableActions()">Connect</app-pan-button>
      </div>
    </app-pan-modal>

    <app-pan-section-header class="mt-4" title="Connected Terminals">
      <app-pan-button [disabled]="disableActions()" action icon="add" color="info" (click)="connectTerminalModal.show()"></app-pan-button>
    </app-pan-section-header>

    <ag-grid-angular [rowData]="connectedTerminals()" [columnDefs]="terminalColumns" [gridOptions]="terminalTable"></ag-grid-angular>
  }
</app-pan-card>

<app-pan-modal
  #cameraDisplayCheck
  size="sm"
  [topLevel]="true"
  [shouldBodyScroll]="false"
  (modalWillOpen)="loadCameraSnapshot()"
  (modalWillClose)="unloadViewCamera()"
>
  <div header>Camera Preview</div>
  <div body>
    @let cameraUrl = viewCameraUrl();

    @if (!cameraUrl) {
      <app-pan-blank-slate>
        <app-pan-spinner size="lg"></app-pan-spinner>
      </app-pan-blank-slate>
    } @else if (cameraUrl === "error") {
      <app-pan-inline-alert [type]="'danger'">Could not load preview for this camera.</app-pan-inline-alert>
    } @else {
      <app-pan-section-header class="mb-2" [title]="'Camera Snapshot Preview'"></app-pan-section-header>
      <img [src]="cameraUrl" alt="camera preview for {{ camera?.camera_name }}" />
    }
  </div>
  <div footer>
    <app-pan-button panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>
